import { render, staticRenderFns } from "./LearningChart.vue?vue&type=template&id=3baaf616&scoped=true&lang=pug&"
import script from "./LearningChart.vue?vue&type=script&lang=ts&"
export * from "./LearningChart.vue?vue&type=script&lang=ts&"
import style0 from "./LearningChart.vue?vue&type=style&index=0&id=3baaf616&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baaf616",
  null
  
)

export default component.exports